import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'

export const SUPPORT_LOCALES = ['en', 'ro']
const localeLoaders = {
    ro: () => import('../../locale/console/ro.json')
}

export function setupI18n (options = { locale: 'en' }) {
    const i18n = createI18n(options)
    setI18nLanguage(i18n, options.locale)
    return i18n
}

export async function setI18nLanguage (i18n, locale) {
    if (!i18n.global.availableLocales.includes(locale)) {
        await loadLocaleMessages(i18n, locale)
    }

    if (i18n.mode === 'legacy') {
        i18n.global.locale = locale
    } else {
        i18n.global.locale.value = locale
    }
    if (document && document.querySelector) {
        document.querySelector('html').setAttribute('lang', locale)
    }
}

export async function loadLocaleMessages (i18n, locale) {
    const loadLocale = localeLoaders[locale]
    if (!loadLocale) throw new Error(`Unsupported console locale: ${locale}`)

    const messages = await loadLocale()

    // set locale and locale message
    i18n.global.setLocaleMessage(locale, messages.default)

    return nextTick()
}
